import { useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Button,
    Card,
    CardContent,
    FormControlLabel,
    Checkbox,
    ToggleButtonGroup,
    ToggleButton,
    TextField,
    Stack,
    Divider,
} from "@mui/material";

import { FormProvider, useForm, Controller, useFieldArray } from "react-hook-form";
import RHFTextField from "../../../../components/ReactHookForm/RHFTextField";
import RHFAutocomplete from "../../../../components/ReactHookForm/RHFAutocomplete";
// import ConditionRow from "./ConditionRow";


export default function AddComponentForm() {

    const methods = useForm({
        defaultValues: {
            configName: "",
            calculationType: "FIXED",
            valueAmount: "",
            conditionalLogic: false,
            conditionText: "",
            applyType: "OR",
            conditions: [
                {
                    ifField: "",
                    comparison: "",
                    amount: "",
                },
            ],
            finalAmount: "",
        },
    });


    const { control, watch, setValue } = methods;

    const { fields, append } = useFieldArray({
        control,
        name: "conditions",
    });

    const calcType = watch("calculationType");

    const conditionalLogic = watch("conditionalLogic");

    const onSubmit = (data) => {
        console.log("FORM:", data);
    };

    return (
        <FormProvider {...methods}>

            <>
                {/* TITLE */}
                <Typography sx={{ mb: 1, color: '#333' }}>
                    Configuration Name
                </Typography>

                {/* CONFIG NAME FIELD */}
                <RHFTextField name="configName" placeholder="Enter allowance or deduction name" rules={{ required: "Configuration name is required" }} sx={{ mb: 2 }} />


<Box>
            <Typography sx={{ mb: 1, color: '#333' }}>
                Component Type
            </Typography>
            <RHFAutocomplete
                options={[
                    { label: 'Allowance', value: 'Allowance' },
                    { label: 'Deductions', value: 'Deductions' },
                    ]}
                name={`componentType`}
                rules={{ required: "Select a field" }}
            />
        </Box>
                {/* CALCULATION TYPE */}
                <Typography sx={{ mb: 1, color: "#333" }}>
                    Calculation Type
                </Typography>

                <Controller
                    name="calculationType"
                    control={methods.control}
                    render={({ field }) => (

                        <Stack sx={{ flexDirection: "row", justifyContent: "center", gap: 3, }}>
                            <Stack onClick={() => { field.onChange('FIXED') }}
                                sx={{ border: `1px solid ${field?.value === 'FIXED' ? '#2563eb' : '#333'}`, padding: 2, width: "100%", alignItems: 'center', borderRadius: 2, background: field?.value === 'FIXED' ? 'rgba(59, 130, 246, 0.2)' : '#fff' }}>
                                <Box sx={{ width: 200 }}>
                                    <Typography variant="subtitle1" textAlign='center'>Fixed Value</Typography>
                                    <Typography sx={{ fontSize: 12, textAlign: 'center' }}>
                                        Fixed monetary amount
                                    </Typography>
                                </Box>
                            </Stack>

                            <Stack onClick={() => { field.onChange('PERCENTAGE') }} sx={{ border: `1px solid ${field?.value === 'PERCENTAGE' ? '#2563eb' : '#333'}`, padding: 2, width: "100%", alignItems: 'center', borderRadius: 2, background: field?.value === 'PERCENTAGE' ? 'rgba(59, 130, 246, 0.2)' : '#fff' }}>
                                <Box sx={{ width: 200 }}>
                                    <Typography variant="subtitle1" textAlign='center'>Percentage Based</Typography>
                                    <Typography sx={{ fontSize: 12, textAlign: 'center' }}>
                                        Percentage of selected base
                                    </Typography>

                                </Box>
                            </Stack>
                        </Stack>
                    )}
                />

                {/* VALUE AMOUNT FIELD */}
                <Typography sx={{ mt: 2, mb: 1, color: "#333" }}>
                    {calcType === "FIXED" ? `Value Amount (₹)` : 'Percentage Value (%)'}
                </Typography>

                <RHFTextField
                    name="valueAmount"
                    placeholder={calcType === "FIXED" ? "Enter fixed amount" : "Enter percentage"} type="number" rules={{ required: "This is required", min: { value: 0, message: "Value cannot be negative" }, }} sx={{ mb: 3 }} />

                {calcType === "PERCENTAGE" &&
                    <>
                        <Typography sx={{ mb: 1, color: '#333' }}>
                            Percentage Calculation Base
                        </Typography>
                        <RHFAutocomplete
                            name="percentegaeBaseCalcuation"
                            rules={{ required: "Percentage Calculation Base is required" }}
                            placeholder="Select"
                            options={[
                                { label: "Gross Salary (Basic + DA + HRA)", value: "Gross Salary (Basic + DA + HRA)" },
                                { label: "Finance", value: "FIN" },
                                { label: "Tech", value: "TECH" },
                            ]}
                        />
                        <Typography sx={{ fontSize: 10, color: 'grey', marginTop: '-10px' }}>Select the base amount for percentage calculation</Typography>
                    </>
                }

                {/* CONDITIONAL LOGIC CHECKBOX */}

                {/* {calcType === "FIXED" && */}

                    <Controller
                        name="conditionalLogic"
                        control={methods.control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        {...field}
                                        checked={field.value}
                                    />
                                }
                                label="Add Conditional Logic"
                            />
                        )}
                    />
                {/* } */}

                {/* CONDITIONAL LOGIC BOX */}
                {conditionalLogic && (
                    <>
                        <Card sx={{ p: 3, background: "#fff" }}>
                            <Typography sx={{ mb: 2, fontSize: 17, fontWeight: 500 }}>
                                Apply When:
                            </Typography>

                            <Stack sx={{ flexDirection: "row", justifyContent: "center", gap: 3, }}>
                                <Stack onClick={() => { setValue("applyType", 'AND') }}
                                    sx={{ border: `1px solid ${watch("applyType") === 'AND' ? '#2563eb' : '#333'}`, padding: 2, width: "100%", alignItems: 'center', borderRadius: 2, background: watch("applyType") === 'AND' ? 'rgba(59, 130, 246, 0.2)' : '#fff' }}>
                                    <Box sx={{ width: 200 }}>
                                        <Typography variant="subtitle1" textAlign='center'>All Conditions (AND)</Typography>
                                        <Typography sx={{ fontSize: 12, textAlign: 'center' }}>
                                            Apply when ALL conditions are met
                                        </Typography>
                                    </Box>
                                </Stack>

                                <Stack onClick={() => { setValue("applyType", "OR") }} sx={{ border: `1px solid ${watch("applyType") === 'OR' ? '#2563eb' : '#333'}`, padding: 2, width: "100%", alignItems: 'center', borderRadius: 2, background: watch("applyType") === 'OR' ? 'rgba(59, 130, 246, 0.2)' : '#fff' }}>
                                    <Box sx={{ width: 200 }}>
                                        <Typography variant="subtitle1" textAlign='center'>Any Condition (OR)</Typography>
                                        <Typography sx={{ fontSize: 12, textAlign: 'center' }}>
                                            Apply when ANY condition is met
                                        </Typography>

                                    </Box>
                                </Stack>
                            </Stack>

<Box sx={{marginTop:1}}>
                        {fields.map((item, index) => (
    <Stack sx={{ flexDirection: 'row', alignItems: 'flex-end', gap: 2 }}>
        <Box>
            <Typography sx={{ mb: 1, color: '#333' }}>
                If
            </Typography>
            <RHFAutocomplete
                options={[{ label: 'Basic', value: 'Basic' }]}
                name={`conditions.${index}.ifField`}
                rules={{ required: "Select a field" }}
            />
        </Box>

        {/* TEXT 1 */}
        <Typography
            sx={{
                color: "#333",
                display: "flex",
                alignItems: "flex-end",
                pb: 0.5, marginBottom:2
            }}
        >
            is
        </Typography>

        <Box>
            <Typography sx={{ mb: 1, color: '#333' }}>
                comparison
            </Typography>
            <RHFAutocomplete
                options={[{ label: 'is Greater than', value: 'is Greater than' }]}
                name={`conditions.${index}.comparison`}
                rules={{ required: "Select a field" }}
            />
        </Box>

        {/* TEXT 2 */}
        <Typography
            sx={{
                color: "#333",
                display: "flex",
                alignItems: "flex-end",
                pb: 0.5, marginBottom:2
            }}
        >
            than
        </Typography>

        <Box sx={{paddingTop:'-10px !important', marginBottom:2}}>
            <Typography sx={{ mb: 1, color: '#333' }}>
                Amount
            </Typography>
            <RHFTextField
                name={`conditions.${index}.amount`}
                rules={{ required: "Enter amount" }}
                type="number"
            />
        </Box>
        
    </Stack>
))}
</Box>

<Divider />
                            {/* Add Another Condition */}
                            <Button
                                variant="outlined"
                                onClick={() =>
                                    append({ ifField: "", comparison: "", amount: "" })
                                }
                                sx={{ mt: 2 }}
                                fullWidth
                            >
                                + Add Another Condition
                            </Button>

<Box sx={{background:'rgba(16, 185, 129, 0.1)', padding:2, borderRadius:2, marginTop:2, border:'1px solid rgba(16, 185, 129, 1)'}}>
<Box>
<Typography>Then apply this amount:</Typography>
<RHFTextField  name="finalAmount"
      rules={{ required: "Final amount is required" }} type="number" placeholder="Amount to apply when condition is met" />
           <Typography sx={{ fontSize: 10, color: 'grey', }}>This amount will be applied when {watch("applyType") === 'AND' ? "All" : "Any"} condition is met</Typography>
      </Box>
</Box>



                        </Card>
                    </>
                )}

                {/* FOOTER BUTTONS */}
                <Grid container spacing={2} sx={{ mt: 4 }}>
                    <Grid item xs={6}>
                        <Button fullWidth variant="outlined" color="inherit">
                            Cancel
                        </Button>
                    </Grid>

                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={methods.handleSubmit(onSubmit)}
                            sx={{
                                bgcolor: "#1f6feb",
                                textTransform: "none",
                                fontWeight: 600,
                            }}
                        >
                            Save Configuration
                        </Button>
                    </Grid>
                </Grid>
            </>

        </FormProvider>
    );
}
